import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type AppDrawerProps = {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  className?: string;
  width?: 'sm' | 'md' | 'lg' | 'xl';
  position?: 'right' | 'left';
  withTopBarOffset?: boolean; // If true, drawer respects global top bar height
};

const widthClasses = {
  sm: 'w-[80%] max-w-sm',
  md: 'w-[90%] max-w-md', 
  lg: 'w-[90%] max-w-lg',
  xl: 'w-[90%] max-w-xl'
};

export default function AppDrawer({ 
  isOpen, 
  onClose, 
  children, 
  className,
  width = 'xl',
  position = 'right',
  withTopBarOffset = true
}: AppDrawerProps) {
  const positionClasses = position === 'right' 
    ? 'right-0' 
    : 'left-0';
    
  const transformClasses = position === 'right'
    ? (isOpen ? 'translate-x-0' : 'translate-x-full')
    : (isOpen ? 'translate-x-0' : '-translate-x-full');

  return (
    <>
      {/* Backdrop */}
      {isOpen && onClose && (
        <div className="fixed inset-0 bg-transparent z-40" onClick={onClose} />
      )}
      <div
        className={cn(
          'fixed bg-background border-l shadow-md transition-transform duration-300 ease-in-out z-50',
          withTopBarOffset 
            ? 'top-14 lg:top-16 h-[calc(100%-3.5rem)] lg:h-[calc(100%-4rem)]' 
            : 'top-0 h-full',
          positionClasses,
          widthClasses[width],
          transformClasses,
          className
        )}
      >
        {children}
      </div>
    </>
  );
}


